import { render, staticRenderFns } from "./VHeaderEdit.vue?vue&type=template&id=d04169c0&scoped=true&"
import script from "./VHeaderEdit.vue?vue&type=script&lang=js&"
export * from "./VHeaderEdit.vue?vue&type=script&lang=js&"
import style0 from "./VHeaderEdit.vue?vue&type=style&index=0&id=d04169c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04169c0",
  null
  
)

export default component.exports